// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"25583191","126":"9cf28c22","144":"38a979d0","147":"23d9aa23","171":"47bf8ff9","374":"830f63da","388":"6b6feb71","507":"8653114b","904":"3419f63c"}[chunkId] + ".chunk.js";
};